import { useQuery } from '@tanstack/react-query'
import { fetchBookAnalysis } from '@/lib/api/bookAnalysis'

/**
 * Learner-stage-specific book analysis for the Book Analysis page.
 * Enabled only when there's a book and an evaluated learner stage (1–5);
 * stage 0 (pre-reader) has no decoding fit by contract.
 *
 * First uncached fetch runs the full engine analysis (~1–3s on long books);
 * the backend caches per (bookId, stage) afterwards, so keep staleTime long.
 */
export function useBookAnalysis(
  bookId: string | null | undefined,
  stage: number | null | undefined,
) {
  const enabled = !!bookId && typeof stage === 'number' && stage >= 1 && stage <= 5

  return useQuery({
    queryKey: ['book-analysis', bookId, stage],
    queryFn: () => fetchBookAnalysis(bookId as string, stage as number),
    enabled,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: 1,
  })
}
